// Tags come from the blog API `category` field. A post can carry more than
// one, separated by commas. Matching ignores case and extra whitespace so
// "Email marketing" and "Email Marketing" are the same filter.

function rawTags(article) {
  const raw = article && typeof article.category === "string" ? article.category : "";

  return raw
    .split(",")
    .map((tag) => tag.trim().replace(/\s+/g, " "))
    .filter(Boolean);
}

function tagKey(tag) {
  return tag.toLowerCase();
}

class BlogCategories {
  static tagsFor(article) {
    return rawTags(article);
  }

  static getCategory(article) {
    return rawTags(article)[0] || "";
  }

  static hasTag(article, tag) {
    if (!tag) return false;
    const key = tagKey(tag);
    return rawTags(article).some((item) => tagKey(item) === key);
  }

  static list(articles) {
    const counts = new Map();

    (articles || []).forEach((article) => {
      rawTags(article).forEach((tag) => {
        const key = tagKey(tag);
        if (!counts.has(key)) counts.set(key, new Map());
        const variants = counts.get(key);
        variants.set(tag, (variants.get(tag) || 0) + 1);
      });
    });

    const labels = [];
    counts.forEach((variants) => {
      let best = "";
      let bestCount = -1;
      variants.forEach((count, tag) => {
        if (count > bestCount || (count === bestCount && tag < best)) {
          best = tag;
          bestCount = count;
        }
      });
      labels.push(best);
    });

    return labels.sort((a, b) => a.localeCompare(b, "en"));
  }
}

export default BlogCategories;
